import NetworkUtil from "./NetworkUtil";

export default class AlertAPI {
    public static async sendAlert(body):Promise<{numberSent:number, success:boolean, reason:string}>{
        return NetworkUtil.makePost("/api/admin/alert", body);
    }

}